import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AccountingModel } from './accountingModel.model';
import { environment } from '../../../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { ApiResponse } from '../../../models/base';

const LIST_ENDPOINT = '/accountingmodel';
const INVESTMENT_ENDPOINT = '/investments';

@Injectable({
  providedIn: 'root',
})
export class AccountingModelService {
  accountingModelList: AccountingModel[] = [];

  private readonly http = inject(HttpClient);

  async importContacts(formData: FormData): Promise<AccountingModel[]> {
    const response = await firstValueFrom(
      this.http.post<ApiResponse<AccountingModel[]>>(
        environment.apiUrl + LIST_ENDPOINT + '/import',
        formData
      )
    );

    return response.data;
  }

  async importData(accountingModels: AccountingModel[]): Promise<string> {
    const response = await firstValueFrom(
      this.http.post<{ message: string }>(
        environment.apiUrl + LIST_ENDPOINT + '/import/add',
        accountingModels
      )
    );

    return response.message;
  }

  async addData(accountingModel: AccountingModel): Promise<AccountingModel> {
    const response = await firstValueFrom(
      this.http.post<ApiResponse<AccountingModel>>(
        environment.apiUrl + LIST_ENDPOINT,
        accountingModel
      )
    );

    return response.data;
  }

  async deleteData(uid: string): Promise<string> {
    const response = await firstValueFrom(
      this.http.delete<{ message: string }>(environment.apiUrl + `${LIST_ENDPOINT}/${uid}`)
    );

    return response.message;
  }

  async editData(uid: string, accountingModel: AccountingModel): Promise<AccountingModel> {
    const response = await firstValueFrom(
      this.http.put<ApiResponse<AccountingModel>>(
        environment.apiUrl + `${LIST_ENDPOINT}/${uid}`,
        accountingModel
      )
    );

    return response.data;
  }

  async loadData(uid: string): Promise<AccountingModel> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<AccountingModel>>(environment.apiUrl + `${LIST_ENDPOINT}/${uid}`)
    );

    return response.data;
  }

  async getList(type: string): Promise<AccountingModel[]> {
    const params = new HttpParams().set('type', type);

    const response = await firstValueFrom(
      this.http.get<ApiResponse<AccountingModel[]>>(environment.apiUrl + LIST_ENDPOINT, {
        params,
      })
    );

    return response.data;
  }

  async getListForContact(): Promise<AccountingModel[]> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<AccountingModel[]>>(
        environment.apiUrl + LIST_ENDPOINT + '/forcontact'
      )
    );

    return response.data;
  }

  async getListInvestmentsAccounts(): Promise<AccountingModel[]> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<AccountingModel[]>>(
        environment.apiUrl + LIST_ENDPOINT + INVESTMENT_ENDPOINT
      )
    );

    return response.data;
  }

  async useConvfactAccount(): Promise<boolean> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<boolean>>(
        environment.apiUrl + LIST_ENDPOINT + '/useConvfactAccount'
      )
    );

    return response.data;
  }
}